var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wx-work-list-panel',{directives:[{name:"loading",rawName:"v-loading",value:(!this.$store.state.work.loaded),expression:"!this.$store.state.work.loaded"}],attrs:{"work-list":_vm.workList,"delivery":_vm.delivery}})}
var staticRenderFns = []

export { render, staticRenderFns }